var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("直播课程统计")]),_c('Select'),(_vm.first)?_c('TableOne'):_c('TableTwo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }